import {MutableRefObject, useContext, useEffect, useRef} from 'react'

import {Context} from './MarginContext'
import {Margin, MarginContext, MarginRectFunction} from './types'

const useMarginContext = (): MarginContext => {
  const contextValue = useContext(Context)

  if (contextValue === null) {
    throw new Error('missing <MarginProvider />')
  }

  return contextValue
}

export const useMargin = (): Margin => useMarginContext()[0]

export const useMarginRef = <T extends Element>(getMarginRect: MarginRectFunction<T>): MutableRefObject<T | null> => {
  const [, strategyEffect] = useMarginContext()
  const ref = useRef<T>(null)

  useEffect(() => {
    const element = ref.current

    if (element) {
      return strategyEffect({
        strategy: () => getMarginRect(element),
      })
    }
    // чтобы не использовать ref можно просто исплючить getMarginRect из зависимостей
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategyEffect])

  return ref
}
